import React from 'react';
import { motion } from 'framer-motion';

/**
 * Shared viewport config for whileInView animations.
 * - amount: 0.01 means "trigger as soon as 1% of element is visible"
 *   This fixes iOS Safari + iframe issues where the default 0.5 threshold never fires.
 * - once: true means animation only plays once per page load
 */
const VIEWPORT = {
  once: true,
  amount: 0.01
} as const;
export function Kicker({
  children
}: {
  children: React.ReactNode;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={VIEWPORT} transition={{
    duration: 0.4
  }} className="font-mono font-bold text-brand uppercase tracking-wider text-sm sm:text-base mb-6" data-id="element-189">
      // {children}
    </motion.div>;
}
export function Divider() {
  return <motion.div initial={{
    opacity: 0,
    scaleX: 0
  }} whileInView={{
    opacity: 1,
    scaleX: 1
  }} viewport={VIEWPORT} transition={{
    duration: 0.5,
    delay: 0.1
  }} className="w-[80px] h-[4px] bg-brand my-8 origin-left" data-id="element-190" />;
}
export function H2({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <motion.h2 initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={VIEWPORT} transition={{
    duration: 0.5
  }} className={`font-archivo text-4xl sm:text-5xl lg:text-6xl uppercase tracking-tight leading-[0.95] mb-8 ${className}`} data-id="element-191">
      {children}
    </motion.h2>;
}